import { render } from "./AddWorkspaceModal.vue?vue&type=template&id=5f5c8629&scoped=true&ts=true"
import script from "./AddWorkspaceModal.vue?vue&type=script&lang=ts"
export * from "./AddWorkspaceModal.vue?vue&type=script&lang=ts"

import "./AddWorkspaceModal.vue?vue&type=style&index=0&id=5f5c8629&lang=scss&scoped=true"
import "./AddWorkspaceModal.vue?vue&type=style&index=1&id=5f5c8629&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f5c8629"]])

export default __exports__